import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {IWorkflowStepComponent} from '@shared/interfaces/workflow-step.interface';
import {WorkflowModel, WorkflowState} from '../../../../workflow/models/workflow.model';
import {Observable, Subject} from 'rxjs';
import {PrepareImportFieldSectionsCommand} from '../../../commands/survey.commands';
import {takeUntil} from 'rxjs/operators';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {Configuration} from '@shared/models/configuration';
import {CommandService} from '@core/services/command.service';

@Component({
    standalone: false,
    selector: 'particle-select-source-step',
  templateUrl: './select-source-step.component.html',
  styleUrls: ['./select-source-step.component.scss']
})
export class SelectSourceStepComponent implements OnInit, OnDestroy, IWorkflowStepComponent {
  private workflow: WorkflowModel;
  private currentStep: WorkflowState;
  sourceKey: string;
  invalidateSubject: InvalidateSubject;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private reportId: string;


  constructor(public changeDetectorRef: ChangeDetectorRef, private commandService: CommandService) {
    this.sourceKey = 'GenericReportFieldSectionChoice';
    this.invalidateSubject = new InvalidateSubject();
  }

  ngOnInit() {
    const config = Configuration.getSmartGridConfig(this.sourceKey);
    config.Parameters['EXECUTION_ID'] = this.reportId;
    const prepareImportFieldSectionsCommand = new PrepareImportFieldSectionsCommand(this.reportId, 'report-source-config');
    this.commandService.executeCommand(prepareImportFieldSectionsCommand)
      .pipe(takeUntil(this.ngUnsubscribe)).subscribe(commandState => {
      this.invalidateSubject.invalidate();
    });
  }
  onLoad(workflow: WorkflowModel, currentStep: WorkflowState) {
    this.workflow = workflow;
    this.currentStep = currentStep;
    const reportIdInput = workflow.States[0].Inputs.find(o => o.Name === 'ReportId');
    if (reportIdInput) {
      this.reportId = reportIdInput.Value;
    }
  }
  canMoveNext$(): Observable<boolean> {

    return null;
  }
  canMoveNext(): boolean {

    return true;
  }
  canCancel(): boolean {
    return true;
  }
  onGridCellValueChange(event) {

  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
